module.exports = __webpack_public_path__ + "static/media/9-10.2249f1b6.mp3";